import { render, staticRenderFns } from "./student-payment.vue?vue&type=template&id=1e826938"
import script from "./student-payment.vue?vue&type=script&lang=js"
export * from "./student-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports